// DEV
export const DEV_URL = 'https://adastra.metacroc-dev.com'
export const DEV_AUTH_URL = 'https://adastra.metacroc-dev.com/auth'

// CEZ
export const CEZ_STAGE_URL = 'https://cez.metacroc-test.com'
export const CEZ_STAGE_AUTH_URL = 'https://cez.metacroc-test.com/auth'

// DRMAX
export const DRMAX_STAGE_URL = 'https://drmax.metacroc-test.com'
export const DRMAX_STAGE_AUTH_URL = 'https://drmax.metacroc-test.com/auth'

// PRIVATBANK
export const PRIVATBANK_STAGE_URL = 'https://privatbank.metacroc-test.com'
export const PRIVATBANK_STAGE_AUTH_URL =
	'https://privatbank.metacroc-test.com/auth'

// GASNET
export const GASNET_STAGE_URL = 'https://gasnet.metacroc-test.com'
export const GASNET_STAGE_AUTH_URL = 'https://gasnet.metacroc-test.com/auth'

// OTHERS
export const LOCALHOST = 'http://localhost'
export const METACROC_HOMEPAGE = 'https://metacroc.com'
